import { render } from "./DsModal.vue?vue&type=template&id=04686e0b&scoped=true"
import script from "./DsModal.vue?vue&type=script&lang=js"
export * from "./DsModal.vue?vue&type=script&lang=js"

import "./DsModal.vue?vue&type=style&index=0&id=04686e0b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04686e0b"]])

export default __exports__